import { render, staticRenderFns } from "./accountants-voor-bedrijven.vue?vue&type=template&id=3a4a32c2"
import script from "./accountants-voor-bedrijven.vue?vue&type=script&lang=js"
export * from "./accountants-voor-bedrijven.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports